var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "middle",
    width: 239,
    height: 239,
    viewBox: "0 0 239 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #circleSmall {\n            animation: rotate 6s linear infinite;\n            transform-origin: 50% 50%;\n            transform-box: fill-box;\n        }\n        @keyframes rotate{\n                    from{\n                    transform: rotate(0deg);}to{\n                    transform: rotate(360deg);\n                    }\n                }\n    ")), /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 239,
    viewBox: "0 0 239 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 119.5,
    r: 86.5,
    fill: "#5C1FDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circleSmall"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 119.5,
    r: 117.444,
    transform: "rotate(-0.280144 119.5 119.5)",
    stroke: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.5,
    cy: 119.5,
    r: 27.5,
    stroke: "#38F9C5",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.fefd4a3c352aa6574ed87beb984e9abe.svg";
export { ForwardRef as ReactComponent };